/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NotificationReadState = {
    Read: 'read',
    Unread: 'unread'
} as const;
export type NotificationReadState = typeof NotificationReadState[keyof typeof NotificationReadState];

